import axios from 'axios'
import { setToken, getToken } from '@/libs/util';
import router from '@/router'
import utils from "@/utils/utils.js";
// axios 配置
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Content-Type'] = 'multipart/form-data';


axios.defaults.timeout = 25000;

axios.defaults.baseURL = 'https://newapi.roonchain.com/api/';

axios.interceptors.request.use((config) => {
  const formData = new FormData();
  for (const key in config.data) {
    formData.append(key, config.data[key])
  }
  const token = getToken();
  if (token) { //判断token是否存在
    formData.append('ApiToken', token)
  }
  const lang = localStorage.getItem('lang') || 'zhtw'
  formData.append('language', lang)
  config.data = formData;
  // config.headers.Authorization = 123;
  return config;
},
  (err) => {
    return Promise.reject(err);
  })



// 请求的结果做统一处理
function request(res, resolve, reject) {
  const { data, status } = res
  if (data.code < 0) {
    if (data.code === -14 || data.code === -999) {
      setToken('')
      router.push({ path: '/' })
    }
    utils.showToast(data.msg)
    throw new Error(data.msg)
  } else {
    resolve(data)
  }
}

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params })
      .then(res => {
        request(res, resolve, reject);
      })
      .catch(err => {
        reject(err);
      })
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        request(res, resolve, reject);
      })
      .catch(err => {
        console.log('err', err);
        reject(err)
      })
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        request(res, resolve, reject);
      })
      .catch(err => {
        reject(err)
      })
  });
}

export function del(url, params = null) {
  return new Promise((resolve, reject) => {
    axios.delete(url, { params })
      .then(res => {
        request(res, resolve, reject);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
